import React, { Fragment, PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { Icon } from "../../../../Common/Icon";

class ContactRowCell extends PureComponent {
  static propTypes = {
    reps: PropTypes.array.isRequired,
    className: PropTypes.string,
    header: PropTypes.string
  };

  static defaultProps = {
    className: "",
    header: ""
  };

  state = {
    isContentVisible: false
  };

  maybeOverflowedRef = React.createRef();

  handleToggleIsContentVisible = () => {
    if (this.maybeOverflowedRef.current.offsetWidth + 1 < this.maybeOverflowedRef.current.scrollWidth) {
      this.setState({ isContentVisible: !this.state.isContentVisible });
    }
  };

  renderContactInformation = () => {
    const [firstRep = {}] = this.props.reps;
    return (
      <Fragment>
        {this.props.reps.map(rep => (
          <p key={rep.id}>
            {rep.callFrom && <span className="representative__contact-label">{`${rep.callFrom}:`}</span>}
            {rep.officePhone && (
              <Fragment>
                <span className="representative__contact-label">T</span>
                <a className="representative__contact-value --link" href={`tel:${rep.officePhone}`}>
                  {rep.officePhone}
                </a>
              </Fragment>
            )}
            {rep.officeFax && (
              <Fragment>
                <span className="representative__contact-label">F</span>
                <a className="representative__contact-value --link" href={`tel:${rep.officeFax}`}>
                  {rep.officeFax}
                </a>
              </Fragment>
            )}
          </p>
        ))}
        {firstRep.email && (
          <a className="representative__contact-value --link" href={`mailto:${firstRep.email}`}>
            <Icon className="representative__contact-icon" id="email" />
            {firstRep.email}
          </a>
        )}
      </Fragment>
    );
  };

  render() {
    return (
      <div
        role="cell"
        className={classNames("sorted-list__data --grouping", this.props.className)}
        onMouseEnter={this.handleToggleIsContentVisible}
        onMouseLeave={this.handleToggleIsContentVisible}
        ref={this.maybeOverflowedRef}>
        {this.props.header && <span className="sorted-list__data-header">{this.props.header}</span>}
        {this.renderContactInformation()}
        {this.state.isContentVisible && <span className="list-popover__content">{this.renderContactInformation()}</span>}
      </div>
    );
  }
}

export default ContactRowCell;



// WEBPACK FOOTER //
// ./src/components/PurchaseOrder/OrderPage/Representative/List/ContactRowCell.js